<script>
// import { resolve } from "$app/paths";
import { Icon } from "$lib/components";
import { socialMediaLinks } from "$lib/data";
import { cn } from "$lib/utils";

let className = "";
export { className as class };

export let iconSize = "size-4";

const socialLink = cn(
  "inline-flex",
  "size-8",
  "items-center",
  "justify-center",
  "gap-x-2",
  "rounded-full",
  "border",
  "border-transparent",
  "text-sm",
  // "font-semibold",
  "text-base-12",
  "transition-all",
  "duration-300",
  "hover:bg-base-6",
  "focus:bg-base-7",
  "focus:outline-none",
  "disabled:pointer-events-none",
  // "disabled:opacity-50",
  // "dark:text-neutral-400",
  // "dark:hover:bg-neutral-700",
  // "dark:focus:bg-neutral-700",
  className,
);

//  "bg-base-transparent size-9 shrink-0 font-medium text-base-12 hover:bg-base-4 focus:bg-base-3 focus:outline-none"
</script>

{#each socialMediaLinks.items as item, index ((index, item.title))}
  <a class={socialLink} href={item.href} target="_blank" rel="nofollow">
    <span class="sr-only">{item.title}</span>
    <Icon name={item.icon} class={iconSize} />
  </a>
{/each}
<slot />
